
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral-delta-3-max-series",
      function () {
        return require("private-next-pages/referral-delta-3-max-series/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral-delta-3-max-series"])
      });
    }
  